export enum EnvironmentType {
  Development = 'Development',
  QATest = 'QA Test',
  QALive = 'QA Live',
  Test = 'Test',
  n5Test = 'n5Test',
  Live = 'Live'
}
